<template>
  <el-dialog v-dialog-drag :visible.sync="showDialog" width="950px" :destroy-on-close="true" :before-close="cancel"
    title="变更信息" class="change-detail-dialog">
    <div class="el-dialog-div">
      <contract-change-sections
        :change-data="changeData"
        :old-data="oldData"
        :new-data="newData"
        :old-value-label="selectDetail['rawData'] ? '变更前' : '当前'"
        new-value-label="变更内容">
      </contract-change-sections>
    </div>
  </el-dialog>
</template>

<script>
import ContractChangeSections from "@/components/sales/ContractChangeSections.vue";
import changeContractMixin from "@/mixins/changeContractMixin";

export default {
  name: "ContractChangeDetail",
  mixins: [changeContractMixin],
  components: { ContractChangeSections },
  props: ['showDialog', 'selectDetail'],
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/contractChangeSections.scss";
</style>
